import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import NoSectionAccess from './NoSectionAccess';
import { api } from '../api/client';
import { useIsAuthenticated } from '../stores/authStore';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      if (!isAuthenticated) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const response = await api.get('/auth/me');
        const user = response.data.data;
        setIsAdmin(user.is_admin === true);
      } catch (error) {
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdmin();
  }, [isAuthenticated]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    // Объяснение вместо молчаливой подмены дашбордом (#337). Редирект здесь
    // был неотличим от поломки: адрес оставался прежним в истории, экран
    // менялся на посторонний, причина нигде не называлась. На ресурсах
    // (проект, продукт) механизм объяснения существовал и работал — на
    // разделах его не было.
    //
    // Остаёмся на том же адресе намеренно: так работает «назад» в браузере, и
    // ссылку можно переслать администратору как есть.
    return <NoSectionAccess />;
  }

  return <>{children}</>;
};

export default AdminRoute;
